var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, } from "vue-property-decorator";
import GeneralInformationView from "../../components/partcreation/generalinformationview.vue";
import HoleCutout from "../../components/partcreation/holecutout.vue";
import { createRectangle, } from "../utilities/geometry";
import { isValid, laserMaterialMap, } from "../utilities/material";
import { createSvg, defaultGeneralInformation, } from "../utilities/partcreation";
import { isNumber, } from "../utilities/wsi4_typeguards";
let RectangleCutout = class RectangleCutout extends Vue {
    constructor() {
        super(...arguments);
        this.cornerRadius = 5.;
        this.dimX = 400.;
        this.dimY = 200.;
        this.generalInformation = defaultGeneralInformation;
        this.holes = [];
        this.holesValid = true;
    }
    close() { }
    validInput(valid) { return valid; }
    transferData() {
        return {
            gasId: this.generalInformation.material.cuttingGasId,
            material: this.generalInformation.material.material,
            name: this.generalInformation.articleName,
            segments: [
                ...this.path.outerPolygon,
                ...this.path.innerPolygons.reduce((arr, i) => [
                    ...arr,
                    ...i,
                ], []),
            ],
            thickness: this.generalInformation.thickness,
        };
    }
    updateSvg() {
        const s = this.$el.querySelector(".part-creation-svg");
        if (s === undefined || s === null) {
            throw Error("Selector '.part-creation-svg' does not match");
        }
        if (s.contains(this.currentSvg)) {
            s.removeChild(this.currentSvg);
        }
        this.currentSvg = createSvg(this.path, {
            addMeasurements: true,
            profileParts: [],
        });
        s.appendChild(this.currentSvg);
    }
    updateInputFields() {
        if (this.holes.length === 0) {
            this.updateData();
        }
    }
    updateData() {
        if (this.validRectangle) {
            this.updateSvg();
            this.transferData();
        }
        this.validInput(this.valid);
    }
    updateGeneralInformation(g) {
        this.generalInformation = g;
        this.updateData();
    }
    isValidNumber(n) { return isNumber(n) && n > 0; }
    isInRange(n, max) { return n < max; }
    updateHoleCutout(holes) {
        this.holes = holes;
        this.updateData();
    }
    updateHolesValid(valid) {
        this.holesValid = valid;
        this.updateData();
    }
    get dimXInMaxRange() {
        return this.dimY < this.dimX ? this.isInRange(this.dimX, Math.max(this.maximalDimX, this.maximaldimY)) : this.isInRange(this.dimX, Math.min(this.maximaldimY, this.maximalDimX));
    }
    get dimXValid() { return this.isValidNumber(this.dimX) && this.dimXInMaxRange && this.sheetMinAreaValid; }
    get dimYInMaxRange() {
        return this.dimY < this.dimX ? this.isInRange(this.dimY, Math.min(this.maximalDimX, this.maximaldimY)) : this.isInRange(this.dimY, Math.max(this.maximaldimY, this.maximalDimX));
    }
    get dimYValid() { return this.isValidNumber(this.dimY) && this.dimYInMaxRange && this.sheetMinAreaValid; }
    get cornerRadiusSmallerSize() { return this.cornerRadius * 2. < this.dimX && this.cornerRadius * 2. < this.dimY; }
    get cornerRadiusValid() {
        return this.cornerRadius === 0. ||
            (this.isValidNumber(this.cornerRadius) && this.isInRange(2. * this.cornerRadius, Math.min(this.maximalDimX, this.maximaldimY))
                && this.cornerRadiusSmallerSize && this.sheetMinAreaValid);
    }
    get laserMaterialMap() { return laserMaterialMap(this.shopConfig, (m) => !isValid(this.shopConfig, [this.generalInformation.thickness], m.material.identifier, m.cuttingGasId)); }
    get sheet() {
        const allowedSheets = this.shopConfig.sheets.filter(s => s.thickness === this.generalInformation.thickness && s.sheetMaterialId === this.generalInformation.material.material.identifier);
        if (allowedSheets.length === 0) {
            return undefined;
        }
        return allowedSheets.reduce((res, s) => (s.dimX * s.dimY > res.dimX * res.dimY) ? s : res, allowedSheets[0]);
    }
    get sheetSizeBorder() { return 40.; }
    get maximalDimX() { return this.sheet === undefined ? 0. : this.sheet.dimX - this.sheetSizeBorder; }
    get maximaldimY() { return this.sheet === undefined ? 0. : this.sheet.dimY - this.sheetSizeBorder; }
    get path() {
        return {
            outerPolygon: createRectangle(this.dimX, this.dimY, this.cornerRadius),
            innerPolygons: this.holes,
        };
    }
    get area() {
        if (this.generalInformation.thickness > Math.max(this.dimX, this.dimY)) {
            return this.generalInformation.thickness * Math.max(this.dimX, this.dimY);
        }
        return this.dimX * this.dimY;
    }
    get minArea() {
        if (!this.generalInformation.valid) {
            return -1;
        }
        const lm = this.shopConfig.laserSheetCuttingMaterial.find(m => m.sheetMaterialId === this.generalInformation.material.material.identifier);
        if (lm === undefined) {
            throw Error("Invalid laserCuttingMaterial");
        }
        const minArea = this.shopConfig.laserSheetCuttingMinAreas.find(l => this.generalInformation.thickness === l.thickness
            && l.sheetCuttingMaterialId === lm.sheetCuttingMaterialId
            && l.laserSheetCuttingGasId === this.generalInformation.material.cuttingGasId);
        if (minArea === undefined) {
            return -1;
        }
        return minArea.area;
    }
    get sheetMinAreaValid() {
        if (this.area === -1) {
            return true;
        }
        return this.area >= this.minArea;
    }
    get validRectangle() {
        return this.generalInformation.valid && this.dimXValid && this.dimYValid && this.cornerRadiusValid && this.sheetMinAreaValid;
    }
    get valid() {
        return this.validRectangle && this.holesValid;
    }
    get toolTip() {
        if (this.valid) {
            return "";
        }
        const m2 = " [mm²]";
        const maxSizeMessage = this.i18n.t("maxSizeInvalid") + this.maximalDimX.toString() + " x " + this.maximaldimY.toString() + m2;
        if (!this.dimXValid) {
            if (!this.isValidNumber(this.dimX)) {
                return this.i18n.t("sizeInvalid");
            }
            if (!this.dimXInMaxRange) {
                return maxSizeMessage;
            }
        }
        else if (!this.dimYValid) {
            if (!this.isValidNumber(this.dimY)) {
                return this.i18n.t("sizeInvalid");
            }
            if (!this.dimYInMaxRange) {
                return maxSizeMessage;
            }
        }
        if (!this.sheetMinAreaValid) {
            return this.i18n.t("sheetMinAreaInvalid") + this.minArea.toString() + m2;
        }
        return this.i18n.t("sizeInvalid");
    }
    get toolTipCornerRadius() {
        if (this.cornerRadiusValid) {
            return "";
        }
        if (!this.isValidNumber(this.cornerRadius)) {
            return this.i18n.t("cornerRadiusInvalid");
        }
        if (!this.cornerRadiusSmallerSize) {
            return this.i18n.t("cornerRadiusSmallerSize");
        }
        return this.i18n.t("cornerRadiusInvalid");
    }
    get outerPolygonData() {
        return {
            dimX: this.dimX,
            dimY: this.dimY,
            cornerRadius: this.cornerRadius,
            thickness: this.generalInformation.thickness,
        };
    }
    mounted() { this.updateData(); }
};
__decorate([
    Prop({ required: true })
], RectangleCutout.prototype, "shopConfig", void 0);
__decorate([
    Inject()
], RectangleCutout.prototype, "i18n", void 0);
__decorate([
    Emit()
], RectangleCutout.prototype, "close", null);
__decorate([
    Emit()
], RectangleCutout.prototype, "validInput", null);
__decorate([
    Emit()
], RectangleCutout.prototype, "transferData", null);
RectangleCutout = __decorate([
    Component({
        components: {
            GeneralInformationView,
            HoleCutout,
        },
        name: "RectangleCutout",
    })
], RectangleCutout);
export default RectangleCutout;
